import { useDispatch } from 'react-redux'
import { useSelector } from '@state/store'
import { useForm } from 'react-hook-form'

import { Button, Grid } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'

import { SelectInput } from '@components/inputs'
import { TextInput } from '@components/inputs'
import {
  WaitingRoom,
  RoomType,
  Office,
  UpdateOfficeDto,
  CreateOfficeDto,
} from '@services/api'
import { MouseEventHandler, useEffect, useMemo, useState } from 'react'
import {
  createDoctorOffice,
  updateDoctorOffice,
} from '../../../../state/thunks/roomThunk'
import { addOfficeSchema } from '../../../../utils/schemas'

type AddOfficeFormProps = {
  row?: Office
  onClose?: () => void
  onCancelButtonPress?: (
    ev: MouseEventHandler<HTMLButtonElement> | undefined,
  ) => void
}

export function OfficesForm({ row, onClose }: AddOfficeFormProps) {
  const dispatch = useDispatch()
  const sites = useSelector(({ site }) => site.sites.datas)

  const [selectedSite, setSelectedSite] = useState<number | null>(null)

  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useForm<WaitingRoom>({
    resolver: yupResolver(addOfficeSchema),
    defaultValues: {
      ...row,
    },
  })

  useEffect(() => {
    if (row?.site) {
      setSelectedSite(row.site.id)
    }
  }, [row])

  const onSubmit = (values: WaitingRoom & { type?: RoomType }) => {
    if (row?.id) {
      const body: UpdateOfficeDto = {
        code: values.code,
        label: values.label,
        siteId: values.siteId,
      }
      dispatch(updateDoctorOffice({ id: row.id, body }))
    } else {
      //add room
      const body: CreateOfficeDto = {
        code: values.code,
        label: values.label,
        siteId: values.siteId,
      }
      dispatch(createDoctorOffice(body))
    }

    if (onClose) onClose()
  }

  const sitesOptions = useMemo(
    () =>
      sites.map((_site) => ({
        label: _site.label,
        value: _site.id,
      })),
    [sites],
  )

  return (
    <Grid container spacing={1} justifyContent="center" alignItems="flex-start">
      <Grid item xs={12}>
        <SelectInput
          value={selectedSite}
          name="siteId"
          options={sitesOptions}
          control={control}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput name="code" errors={errors} control={control} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput name="label" errors={errors} control={control} />
      </Grid>
      <Grid container gap={2} justifyContent="flex-end" mt={3}>
        {onClose && (
          <Button onClick={onClose} variant="outlined">
            Annuler
          </Button>
        )}
        <Button
          onClick={handleSubmit(onSubmit)}
          color="secondary"
          variant="contained"
        >
          Sauvegarder
        </Button>
      </Grid>
    </Grid>
  )
}
